export const initialFormState = {
    helpTextsById: {},
    isSubmitting: false
};
//# sourceMappingURL=state.js.map